import React, { useRef, useState } from 'react';

import Icon from '../../../molecules/Icon';
import CategoryButton from './CategoryButton';

import { formattedFilter } from '../utils/functions';

import { color } from '../../../atoms/colors';
import {
  ClearBtn,
  Container,
  Filter,
  FilterBtn,
  FilterDropdown,
  FilterDropdownWrapper,
  OrderButton,
} from '../styles/Filters.styled';

const Filters = ({
  filters,
  filterState,
  activeFilters,
  setActiveFilters,
  sortOrder,
  setSortOrder,
}) => {
  const [openDropdown, setOpenDropdown] = useState(null);
  const closeTimeoutRef = useRef(null);

  if (!filters || filters.length === 0) {
    return null;
  }

  const handleMouseLeave = () => {
    closeTimeoutRef.current = setTimeout(() => {
      setOpenDropdown(null);
    }, 100);
  };

  const hasActiveFilters = Object.values(activeFilters).some(
    categories => categories.length > 0
  );

  return (
    <Container>
      {filters.map((filter, index) => {
        if (!filter) return null;
        const { categories, title } = filter;

        const showSpacer = index !== filters.length - 1 || hasActiveFilters;
        const isHovered = openDropdown === title;

        return (
          <React.Fragment key={title}>
            <Filter>
              <FilterBtn
                type="button"
                isHovered={isHovered}
                onMouseLeave={handleMouseLeave}
                onClick={() => setOpenDropdown(title)}
              >
                {title}
                <Icon
                  id="chevron-down"
                  strokeColor={color.darkBlue[1000]}
                  width="20px"
                  height="20px"
                />
              </FilterBtn>
              {isHovered && (
                <FilterDropdown
                  onMouseEnter={() => clearTimeout(closeTimeoutRef.current)}
                  onMouseLeave={handleMouseLeave}
                >
                  <FilterDropdownWrapper>
                    {categories?.map(category => {
                      const filterFormatted = formattedFilter(filter.title);
                      const isActive = activeFilters[filterFormatted]?.includes(
                        category
                      );
                      if (title === 'Sort By') {
                        return (
                          <OrderButton
                            onClick={() => setSortOrder(category)}
                            active={sortOrder === category}
                          >
                            {category}
                          </OrderButton>
                        );
                      }
                      return (
                        <CategoryButton
                          filter={filter}
                          category={category}
                          isActive={isActive}
                          setActiveFilters={setActiveFilters}
                        />
                      );
                    })}
                  </FilterDropdownWrapper>
                </FilterDropdown>
              )}
            </Filter>
            {showSpacer && <div className="spacer" />}
          </React.Fragment>
        );
      })}
      {hasActiveFilters && (
        <ClearBtn onClick={() => setActiveFilters(filterState)}>
          <Icon
            id="x-circle"
            width="20px"
            height="20px"
            fillColor={color.darkBlue[400]}
          />
          Clear all
        </ClearBtn>
      )}
    </Container>
  );
};

export default Filters;
